<template>
  <div v-if="!sezioni"></div>
  <div v-else>
    <div v-if="collezione" :style="{'background-image':'url(/collezioni/' + this.testate[this.collezione.val('nome')] + ')'}" class="collections-hero sections-hero">
      <h2 class="text-center">{{ this.collezione.val("nome") }}<br> <span>collection</span></h2>
    </div>
    <div class="container">

      <div class="breadcrumb py-3">
        <a href="/"> {{ 'Home' }} </a>
        <span> {{ ' / ' }} </span>
        <a :href="'/' "> {{ 'Collezioni' }} </a>
        <span> {{ ' / ' }} </span>
        <p> {{ this.$route.params.collezione }} </p>
      </div>

      <div class="pt-5 text-center" v-if="collezione">
        <p v-html="collezione.val('intro_collezione')"> </p>
      </div>
      <div>
        <div v-for="sez,index in sezioni" :key="sez.id">
          <div class="sezione-name text-uppercase">{{ sez.val("titolo_sezione_web") }}</div>
          <div class="product-container">
            <div
              v-for="prod in sez.relSync('prodotti')"
              :key="prod.id"
              class="product-box"
            >
              <div class="prod-event">
                <div
                  @click="goToPage('product/' + clearParams(prod.val('nome')))"
                  style="text-decoration: none; color: #000;"
                  class="prod-href"
                >
                  <div class="square">
                    <div class="square-content">
                        <img v-if="prod.val('image')" class="img-fluid" :src="prod.val('image').link({'x':400,'y':400,'ext':'jpg'})" :alt="prod.val('nome')">
                        <img v-else class="img-fluid" src="/collezioni/placeholder.png" alt="">
                    </div>
                  </div>
                  <div class="prod-name">{{ prod.val("nome") }}</div>
                  <div class="desc-prod">{{ prod.val("descrizione_estesa") }}</div>
                </div>
              </div>
            </div>
          </div>
          <div :class="{ 'divider' : index < sezioni.length -1 }"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">
import { defineComponent } from "@vue/runtime-core";
import { Schema, Thing } from "onpage-js";

export default defineComponent({
  props: {
    schema: {
      type: Schema,
      required: true,
    },
  },
  mounted() {
    window.document.getElementById('app').scrollIntoView()
  },
  data() {
    return {
      collezione: null,
      sezioni: null,
      cerca: "",
      prodotti: {
              things: Thing
          },
          testate:{
            Nude: 'testata_nude_01.jpg',
            Fiore: 'testata_fiore_01.jpg',
            'Jar e Composter': 'testata_jar_01.jpg',
            Terra: 'testata_terra_01.jpg',
            'Pet Collection': '',
          },
    };
  },

  async created() {
    this.refreshSezioni();
    this.refreshCollezione();
  },
  computed: {
    sezioni_query(){
      const schema = this.schema;
      if (!schema) return;
      const q = schema.query("sezioni").where('collezioni.nome', this.resolve(this.$route.params.collezione)).with("prodotti");
      return q;
    },
    collezioni_query(){
      const schema = this.schema;
      if(!schema) return;
      const c = schema.query("collezioni");
      return c;
    }
  },
  methods: {
    goToPage(path) {
      console.log(path)
      this.$router.push({ path: `/${path.replace('#/', '')}` })
    },
    async refreshSezioni() {
      this.sezioni = await this.sezioni_query?.all();
    },
    async refreshCollezione(){
      let collezioni = await this.collezioni_query.all();
      this.collezione = collezioni.filter(col => col.val('nome').match(this.resolve(this.$route.params.collezione)))[0];
    },
    clearParams(nome){
      return nome.replaceAll("/","-").replaceAll(" ","_");
    },
    resolve(param){
      return param.replaceAll("-","/").replaceAll("_"," ");  
    }
  },
  watch: {
  },
});
</script>

<style>
.sections-hero{
  background-size: cover;
}
.sections-hero h2{
  font-size: 112px;
  line-height: 50px;
  font-weight: 200;
}
.sections-hero h2 span{
  font-size: 32px;
  text-transform: none;
}
.sezione-name{
  padding: 1em;
  text-align: center;
  font-size: 2em;
}
.product-container {
  display: flex;
  flex-wrap: wrap;
}
.product-box {
  width: calc(100% / 4);
  padding: 10px;
  transition: all .3s;
  margin-bottom: 20px;
}
.product-box:hover{
  transform: scale(1.04);
}
.square {
  position: relative;
  width: 100%;
}
.square:after {
  content: "";
  display: block;
  padding-bottom: 100%;
}
.square-content {
  position: absolute;
  width: 100%;
  height: 100%;
}
.prod-name {
  padding-bottom: 0 !important;
  text-align: center;
  text-transform: uppercase;
}
.desc-prod{
  font-size: 16px;
  font-weight: 100;
  text-align: center;
  color: grey;
}

@media (max-width: 992px){
  .product-box{
    width: calc(100%/3);
  }
}
@media (max-width: 768px){
  .product-box{
    width: calc(100%/2);
  }
}
@media (max-width: 440px){
  .product-box{
    width: 100%;
  }
}
</style>
